import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbd3d8ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-11" }
const _hoisted_4 = { class: "fw-bold mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-10" }, "「アルムナイ登録フォーム設定」で在籍確認に必要な項目を追加している場合、その項目と回答を確認することができます。", -1))
const _hoisted_6 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_8 = { class: "w-max-content col-lg-2" }
const _hoisted_9 = { class: "col-lg-10 word-wrapper" }
const _hoisted_10 = {
  key: 1,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_11 = { class: "w-max-content col-lg-2" }
const _hoisted_12 = { class: "col-lg-10 word-wrapper" }
const _hoisted_13 = {
  key: 2,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_14 = { class: "w-max-content col-lg-2" }
const _hoisted_15 = {
  key: 0,
  class: "col-lg-10"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" ～ ")
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 3,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_20 = { class: "w-max-content col-lg-2" }
const _hoisted_21 = { class: "col-lg-10" }
const _hoisted_22 = {
  key: 4,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_23 = { class: "w-max-content col-lg-2" }
const _hoisted_24 = { class: "col-lg-10 text-break" }
const _hoisted_25 = {
  key: 5,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_26 = { class: "w-max-content col-lg-2" }
const _hoisted_27 = { class: "col-lg-10 word-wrapper" }
const _hoisted_28 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_29 = {
  key: 6,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_30 = { class: "w-max-content col-lg-2" }
const _hoisted_31 = { class: "col-lg-10 word-wrapper" }
const _hoisted_32 = {
  key: 7,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_33 = { class: "w-max-content col-lg-2" }
const _hoisted_34 = { class: "col-lg-10 word-wrapper" }
const _hoisted_35 = {
  key: 8,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_36 = { class: "w-max-content col-lg-2" }
const _hoisted_37 = { class: "col-lg-10 word-wrapper" }
const _hoisted_38 = {
  key: 9,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_39 = { class: "w-max-content col-lg-2" }
const _hoisted_40 = {
  key: 0,
  class: "col-lg-10"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("～")
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 10,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_45 = { class: "w-max-content col-lg-2" }
const _hoisted_46 = { class: "col-lg-10" }
const _hoisted_47 = {
  key: 11,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_48 = { class: "w-max-content col-lg-2" }
const _hoisted_49 = { class: "col-lg-10 text-break" }
const _hoisted_50 = {
  key: 12,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_51 = { class: "w-max-content col-lg-2" }
const _hoisted_52 = { class: "col-lg-10" }
const _hoisted_53 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_54 = {
  key: 13,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_55 = { class: "w-max-content col-lg-2 text-max-content" }
const _hoisted_56 = {
  key: 0,
  class: "col-lg-10 text-break"
}
const _hoisted_57 = {
  key: 1,
  class: "col-lg-10 text-break pre-line"
}
const _hoisted_58 = {
  key: 14,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_59 = { class: "w-max-content col-lg-2 text-max-content" }
const _hoisted_60 = {
  key: 0,
  class: "col-lg-10 text-break"
}
const _hoisted_61 = {
  key: 1,
  class: "col-lg-10 text-break pre-line"
}
const _hoisted_62 = {
  key: 15,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_63 = { class: "w-max-content col-lg-2 text-max-content" }
const _hoisted_64 = {
  key: 0,
  class: "col-lg-10 text-break"
}
const _hoisted_65 = {
  key: 1,
  class: "col-lg-10 text-break pre-line"
}
const _hoisted_66 = {
  key: 16,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_67 = { class: "w-max-content col-lg-2 text-max-content" }
const _hoisted_68 = {
  key: 0,
  class: "col-lg-10 text-break"
}
const _hoisted_69 = {
  key: 1,
  class: "col-lg-10 text-break pre-line"
}
const _hoisted_70 = {
  key: 17,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_71 = { class: "w-max-content col-lg-2 text-max-content" }
const _hoisted_72 = {
  key: 0,
  class: "col-lg-10 text-break"
}
const _hoisted_73 = {
  key: 1,
  class: "col-lg-10 text-break pre-line"
}
const _hoisted_74 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_75 = {
  key: 18,
  class: "col-lg-12 row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_76 = { class: "text-break pre-line" }
const _hoisted_77 = { class: "d-flex gap-4 justify-content-center" }

import { onMounted, computed, PropType, ref } from 'vue'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { COMMUNITY_ALUMNUS_STORE, REGISTER_STORE } from '@/store/constants'
import { getAdditionalInformationChoiceOptionDisplayDataOE30, checkAdditionalInformationChoiceOptionDisplayData, normalizedDisplayText } from '@/utils'
import { StatusAlumniAccount } from '@/constants/index'
import { Modal } from 'bootstrap'
import InformationModal from './InformationModal.vue'
import InformationConfirmModal from './InformationConfirmModal.vue'
import StatusUpdateModal from './StatusUpdateModal.vue'
import communityAlumnusServices from '@/services/community-alumnus.services'
import { useToast } from 'vue-toastification'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object as PropType<{
    [key: string]: string
  }>,
  status: String,
},
  emits: ['getListData'],
  setup(__props, { emit }) {

const router = useRouter()
const toast = useToast()

const formData = ref({
  additional_information_1: '',
  additional_information_2: '',
  additional_information_3: '',
  additional_information_4: '',
  additional_information_5: '',
  corporation_department_name: '',
  corporation_edit_history_notes: '',
  corporation_email: '',
  corporation_employee_id: '',
  corporation_end_period: '',
  corporation_family_name: '',
  corporation_given_name: '',
  corporation_organization_name: '',
  corporation_start_period: '',
  school_department_name: '',
  school_email: '',
  school_end_period: '',
  school_faclty_name: '',
  school_family_name: '',
  school_given_name: '',
  school_organization_name: '',
  school_start_period: '',
  school_student_id: '',
})
const visible = ref(false)
const store = useStore()
const route = useRoute()
const dataDetail = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_DETAIL_ALMNUS]?.detailAlmnus)
const communityRequiredData = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])
const informationModalRef = ref()
const informationModalClearRef = ref()
const statusUpdateModalRef = ref()
const informationConfirmModalRef = ref()
const serverError = ref<boolean>(false)

const dataBackModalEdit = ref()

onMounted(async () => {
  informationModalRef.value = new Modal(document.getElementById('informationModal'))
  informationConfirmModalRef.value = new Modal(document.getElementById('informationConfirmModal'))
  statusUpdateModalRef.value = new Modal(document.getElementById('statusUpdateModal'))
  try {
    if (route?.params?.id) {
      await store.dispatch(REGISTER_STORE.ACTIONS.SET_COMMUNITY_REQUIRED_COLUMNS, {
        community_id: route?.params?.id,
        params: { idAlumni: route.params?.idAlumni, userType: 'community_admin' },
      })
    }
  } catch (error) {
    console.log(error)
  }
})

const backToList = () => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/alumnus?management_no=desc`)
}

const showInformationModal = () => {
  informationModalClearRef.value.handleFormData(dataDetail.value?.obtained_information)
  visible.value = true
  informationModalRef.value.show()
}
const closeInformationModal = () => {
  visible.value = false
  informationModalRef.value.hide()
}
const closeSuccessModal = () => {
  statusUpdateModalRef.value.hide()
}
const onConfirmInformationModal = (data) => {
  formData.value = data
  closeInformationModal()
  setTimeout(() => {
    showInformationConfirmModal()
  }, 500)
}

const convertDateFormat = (dateStr: string) => {
  // Check if the format is Y/M using a regex
  const ymFormat = /^\d{4}\/\d{2}$/

  // If dateStr matches the Y/M format, then convert it
  if (ymFormat.test(dateStr)) {
    const [year, month] = dateStr.split('/')
    const formattedDate = `${year}/${month}/01`
    return formattedDate
  }

  // If it doesn't match the Y/M format, return dateStr unchanged
  return dateStr
}
const handleSubmit = async (): Promise<void> => {
  try {
    let payload = { ...formData.value }
    payload.corporation_start_period = convertDateFormat(formData.value.corporation_start_period)
    payload.corporation_end_period = convertDateFormat(formData.value.corporation_end_period)
    payload.school_start_period = convertDateFormat(formData.value.school_start_period)
    payload.school_end_period = convertDateFormat(formData.value.school_end_period)
    const response = await communityAlumnusServices.updateAlmunusAdditionalDetailApi({
      id: route.params?.id,
      idAlumni: route.params?.idAlumni,
      data: payload,
    })

    if (response.status === 200) {
      serverError.value = false
      closeInformationConfirmModal(false)
      return
    } else {
      serverError.value = true
      if (response?.response?.data?.data[0]?.message_code === 'VALIDATE_ALREADY_UPDATED_USER') {
        informationConfirmModalRef.value.hide()
        toast.error({
          component: ErrorToast,
          props: {
            messageCode: 'VALIDATE_ALREADY_UPDATED_USER',
          },
        })
      } else if (response?.response?.data?.data[0]?.message_code === 'ERROR_ADDITIONAL_INFORMATIONS') {
        informationConfirmModalRef.value.hide()
        toast.error({
          component: ErrorToast,
          props: {
            messageCode: 'ERROR_ADDITIONAL_INFORMATIONS',
          },
        })
        emit('getListData')
      } else {
        closeInformationConfirmModal(true)
      }
    }
  } catch (error) {
    closeInformationConfirmModal(true)
  }
}
const showInformationConfirmModal = () => {
  informationConfirmModalRef.value.show()
}
const onConfirmInformationConfirmModal = () => {
  handleSubmit()
}
const closeInformationConfirmModal = (isError: boolean) => {
  informationConfirmModalRef.value.hide()
  serverError.value = isError
  setTimeout(() => {
    statusUpdateModalRef.value.show()
  }, 500)
}

const onBackModalEdit = () => {
  dataBackModalEdit.value = formData.value
  visible.value = true
  informationModalRef.value.show()
}
const fetchDataDetail = () => {
  emit('getListData')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(translate)('OE30additionalItems')), 1),
          _hoisted_5
        ])
      ]),
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(translate)('SA20information')), 1),
      (__props.data?.hasOwnProperty('corporation_organization_name'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('SA20corporationOrganizationName')), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(__props.data?.corporation_organization_name), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('corporation_department_name'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)('enrolledDepartmentName')), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(__props.data?.corporation_department_name), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('corporation_start_period') && __props.data?.hasOwnProperty('corporation_end_period'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('enrollment')), 1),
            (__props.data?.corporation_start_period && __props.data?.corporation_end_period)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (__props.data?.corporation_start_period)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(dayjs)(__props.data?.corporation_start_period).format('YYYY/M')), 1))
                    : _createCommentVNode("", true),
                  _hoisted_17,
                  (__props.data?.corporation_end_period)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(dayjs)(__props.data?.corporation_end_period).format('YYYY/M')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('corporation_employee_id'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(translate)('SA25employeeID')), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(__props.data?.corporation_employee_id), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('corporation_email'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)('enrolledTimeEmailID')), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(__props.data?.corporation_email), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('corporation_family_name') && __props.data?.hasOwnProperty('corporation_given_name'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)('OE30nameAtTime')), 1),
            _createElementVNode("div", _hoisted_27, _toDisplayString(!__props.data?.corporation_family_name && !__props.data?.corporation_given_name ? '' : __props.data?.corporation_family_name + ' ' + __props.data?.corporation_given_name), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h3", _hoisted_28, _toDisplayString(_unref(translate)('SA20informationAtSchool')), 1),
      (__props.data?.hasOwnProperty('school_organization_name'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(translate)('SA20schoolOrganizationName')), 1),
            _createElementVNode("div", _hoisted_31, _toDisplayString(__props.data?.school_organization_name), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('school_faclty_name'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(translate)('SA20facultyName')), 1),
            _createElementVNode("div", _hoisted_34, _toDisplayString(__props.data?.school_faclty_name), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('school_department_name'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(translate)('SA20departmentName')), 1),
            _createElementVNode("div", _hoisted_37, _toDisplayString(__props.data?.school_department_name), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('school_start_period') && __props.data?.hasOwnProperty('school_end_period'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(translate)('SA20periodOfEnrollment')), 1),
            (__props.data?.school_start_period && __props.data?.school_end_period)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (__props.data?.school_start_period)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_unref(dayjs)(__props.data?.school_start_period).format('YYYY/M')), 1))
                    : _createCommentVNode("", true),
                  _hoisted_42,
                  (__props.data?.school_end_period)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_unref(dayjs)(__props.data?.school_end_period).format('YYYY/M')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('school_student_id'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)('SA20studentID')), 1),
            _createElementVNode("div", _hoisted_46, _toDisplayString(__props.data?.school_student_id), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('school_email'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(translate)('SA20emailAttendSchool')), 1),
            _createElementVNode("div", _hoisted_49, _toDisplayString(__props.data?.school_email), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('school_family_name') && __props.data?.hasOwnProperty('school_given_name'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createElementVNode("label", _hoisted_51, _toDisplayString(_unref(translate)('SA20nameAtSchool')), 1),
            _createElementVNode("div", _hoisted_52, _toDisplayString(!__props.data?.school_family_name && !__props.data?.school_given_name ? '' : __props.data?.school_family_name + ' ' + __props.data?.school_given_name), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h3", _hoisted_53, _toDisplayString(_unref(translate)('SA20additionalInformation')), 1),
      (__props.data?.hasOwnProperty('additional_information_1'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
            _createElementVNode("label", _hoisted_55, _toDisplayString(_unref(communityRequiredData)?.additional_information_1_question), 1),
            (_unref(checkAdditionalInformationChoiceOptionDisplayData)(__props.data?.additional_information_1))
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(__props.data?.additional_information_1), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_unref(normalizedDisplayText)(__props.data?.additional_information_1)), 1))
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('additional_information_2'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _createElementVNode("label", _hoisted_59, _toDisplayString(_unref(communityRequiredData)?.additional_information_2_question), 1),
            (_unref(checkAdditionalInformationChoiceOptionDisplayData)(__props.data?.additional_information_2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(__props.data?.additional_information_2), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_unref(normalizedDisplayText)(__props.data?.additional_information_2)), 1))
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('additional_information_3'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
            _createElementVNode("label", _hoisted_63, _toDisplayString(_unref(communityRequiredData)?.additional_information_3_question), 1),
            (_unref(checkAdditionalInformationChoiceOptionDisplayData)(__props.data?.additional_information_3))
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(__props.data?.additional_information_3), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_unref(normalizedDisplayText)(__props.data?.additional_information_3)), 1))
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('additional_information_4'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
            _createElementVNode("label", _hoisted_67, _toDisplayString(_unref(communityRequiredData)?.additional_information_4_question), 1),
            (_unref(checkAdditionalInformationChoiceOptionDisplayData)(__props.data?.additional_information_4))
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(__props.data?.additional_information_4), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_unref(normalizedDisplayText)(__props.data?.additional_information_4)), 1))
          ]))
        : _createCommentVNode("", true),
      (__props.data?.hasOwnProperty('additional_information_5'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(communityRequiredData)?.additional_information_5_question), 1),
            (_unref(checkAdditionalInformationChoiceOptionDisplayData)(__props.data?.additional_information_5))
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(__props.data?.additional_information_5), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_unref(normalizedDisplayText)(__props.data?.additional_information_5)), 1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h3", _hoisted_74, _toDisplayString(_unref(translate)('OE30corporationHistoryNotes')), 1),
      (__props.data?.corporation_edit_history_notes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, _toDisplayString(__props.data?.corporation_edit_history_notes), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_77, [
        _createVNode(Button, {
          title: _unref(translate)('back'),
          type: 'secondary',
          onClick: backToList
        }, null, 8, ["title"]),
        (__props.status !== _unref(StatusAlumniAccount).leave)
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              title: _unref(translate)('edit1'),
              type: 'secondary',
              onClick: showInformationModal
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock(_KeepAlive, null, [
      _createVNode(InformationModal, {
        ref: (_value, _refs) => {
          _refs['informationModalClearRef'] = _value
          informationModalClearRef.value = _value
        },
        onOnCloseModal: closeInformationModal,
        onOnConfirm: onConfirmInformationModal,
        dataConfirm: dataBackModalEdit.value,
        visible: visible.value
      }, null, 8, ["dataConfirm", "visible"])
    ], 1024)),
    _createVNode(InformationConfirmModal, {
      onOnCloseModal: closeInformationConfirmModal,
      onOnConfirm: onConfirmInformationConfirmModal,
      onOnBackModalEdit: onBackModalEdit,
      formData: formData.value
    }, null, 8, ["formData"]),
    _createVNode(StatusUpdateModal, {
      onOnCloseModal: closeSuccessModal,
      serverError: serverError.value,
      onOnFetchDataDetail: fetchDataDetail
    }, null, 8, ["serverError"])
  ], 64))
}
}

})